import psl_ui from '../../libs/psl_ui.js';
import {wait} from '../../libs/psl_polyfills.js';

import audio from '../../components/audio.js';

import instructions from '../../components/instructions/component.js';
import steps_component from '../../components/steps/component.js';

import './style.scss';
import template from './template.pst';


psl_ui.templates.add('page_this_or_that',template);

const {el,rpoints}=psl_ui.templates.render('page_this_or_that');

rpoints.option_left.addEventListener('click',e=>{
	if(_state.status==='correct' || _state.status==='incorrect') return;
	_unblur(false);
	_select('left');
});
rpoints.option_right.addEventListener('click',e=>{
	if(_state.status==='correct' || _state.status==='incorrect') return;
	_unblur(false);
	_select('right');
});

rpoints.finish.addEventListener('click',()=>{
	_ext.hide();
	if(_clb) _clb();
});

let _state={
	finished:0,
	step:0,
	status:'question',
	selected:undefined,
	answers:[],
};

let _clb;

const _unblur = (v=true)=>{
	rpoints.choices.classList.remove('blur');

	rpoints.option_left.removeAttribute('tabindex');
	rpoints.option_left.removeAttribute('aria-hidden');
	rpoints.option_right.removeAttribute('tabindex');
	rpoints.option_right.removeAttribute('aria-hidden');

	rpoints.result.removeAttribute('aria-hidden');
	rpoints.choices.removeAttribute('aria-hidden');
	rpoints.desc.removeAttribute('aria-hidden');

	if(v) rpoints.choice_options.focus();
}

window.addEventListener('resize',()=>{
	if(!el.parentNode) return;
	_resize();
});

function _resize(){
	let width=window.innerWidth;
	let height=window.innerHeight;
	let coef = 1;

	if(width>height){
		width=width/1920;
		height=height/1080;
	} else {
		width=width/900;
		height=height/1700;
	}

	coef = Math.min(width,height);

	rpoints.container.style.transform=`scale3d(${coef},${coef},1)`;
}

const _seeds = [];

const init = async (clb)=>{
	instructions.text='Of the two answers— This or That?— which one would help keep you safest on your bike?';

	instructions.append(rpoints.container,_unblur);
	rpoints.choices.classList.add('blur');

	rpoints.choices.appendChild(steps_component.view);

	_state={
		finished:0,
		step:0,
		status:'question',
		selected:undefined,
		answers:[],
	};

	rpoints.result.classList.add('hidden');
	rpoints.finish.classList.add('hidden');
	rpoints.finish.setAttribute('tabindex','-1');
	rpoints.finish.setAttribute('aria-hidden',"true");

	for(let i=0;i<_answers.length;i++){
		_seeds[i]=([0,1]).sort(()=>(0.5-Math.random()));
	}

	_clb=clb;

	await _render();

	rpoints.option_left.setAttribute('tabindex','-1');
	rpoints.option_left.setAttribute('aria-hidden',"true");
	rpoints.option_right.setAttribute('tabindex','-1');
	rpoints.option_right.setAttribute('aria-hidden',"true");

	rpoints.result.setAttribute('aria-hidden','true');
	rpoints.choices.setAttribute('aria-hidden','true');
	rpoints.desc.setAttribute('aria-hidden','true');
}

const _answers=[
	'Bike helmets are the best way to protect your head from injuries during a crash. Leave the other hats at home.',
	'Flips flops and sandals can fall off while riding. Stick to sneakers, but tuck and tie your laces so they don\'t get caught in the chain.',
	'It\'s always best to wear bright colors when biking. You should also have lights and reflectors on your bike, especially at night.',
	'Headphones are great at home, but never wear them biking. You need to be able to hear and pay attention to your surroundings.',
	//'You always ride with the flow of traffic, not against it. So you\'ll be on the right side.',
	'Put your phone down when you\'re riding and carry all items in a backpack. Put both hands on the handlebars and pay full attention.'
];

const _labels=[
	['Baseball cap', 'Helmet'],
	['Flip flops', 'Sneakers'],
	['Black t-shirt', 'Bright orange t-shirt'],
	['Headphones', 'No headphones'],
	//['Sign indicating movement against traffic', 'Sign indicating movement with traffic'],
	['Cell phone', 'no cell phone']
];

const _select = s => {
	instructions.hide();
	_state.selected=s;
	_state.status='answered';

	_render_steps();
	_render_options();
}

const _check_answer = () => {
	let seeds = _seeds[_state.step];

	_state.answers[_state.step]=_state.selected;

	if((_state.selected==='left' && seeds[0]===1) || (_state.selected==='right' && seeds[1]===1)){
		_state.status='correct';
		audio.play(_state.step===(_answers.length-1)?'finished':'correct');
	} else {
		audio.play('plunger');
		_state.status = 'incorrect';
	}
	_state.finished+=1;

	_render_result();
	_render_steps();
	_render_options();
}

const _get_answer = () => {
	if(_state.answers[_state.step]) return _state.answers[_state.step];
	return _state.selected;
}

const _go_to = (i) => {
	_state.step = i;
	if(_state.answers[i]){
		_state.status = (_state.answers[i]==='left' && _seeds[i][0]===1) || (_state.answers[i]==='right' && _seeds[i][1]===1) ? 'correct' : 'incorrect';
		_state.selected = _state.answers[i];
	} else {
		_state.status = 'question';
		_state.selected = undefined;
	}
	_render_options();
	_render_steps();
	_render_result();

	rpoints.choice_options.focus();
}

const _next = () => {
	_state.step+=1;
	_state.status = 'question';
	_state.selected = undefined;
	_render_options();
	_render_steps();
	_render_result();

	rpoints.choice_options.focus();
}

const _render_options = ()=>{
	let answer = _get_answer();
	rpoints.option_left.className=`option left i${_state.step}_${_seeds[_state.step][0]} ${answer==='left'?'selected':''}`;
	rpoints.option_right.className=`option right i${_state.step}_${_seeds[_state.step][1]} ${answer==='right'?'selected':''}`;

	rpoints.option_left.setAttribute('aria-checked',answer==='left');
	rpoints.option_right.setAttribute('aria-checked',answer==='right');

	rpoints.option_left.setAttribute('aria-label',`${_state.answers[_state.step]==='left' && _seeds[_state.step][0]===1?'Correct: ':''}${_labels[_state.step][_seeds[_state.step][0]]}`);
	rpoints.option_right.setAttribute('aria-label',`${_state.answers[_state.step]==='right' && _seeds[_state.step][1]===1?'Correct: ':''}${_labels[_state.step][_seeds[_state.step][1]]}`);

	if(_state.status==='question' || _state.status==='answered'){
		rpoints.choice_options.classList.remove('disabled');
		rpoints.option_left.removeAttribute('tabindex');
		rpoints.option_right.removeAttribute('tabindex');
	} else {
		rpoints.choice_options.classList.add('disabled');
		rpoints.option_left.setAttribute('tabindex','-1');
		rpoints.option_right.setAttribute('tabindex','-1');
	}
}

const _render = () => Promise.all([
	_render_steps(),
	_render_options(),
	_render_result()
]);

const _render_steps = () => {
	const steps = [];
	for(let i=0;i<_answers.length;i++){
		if(i<_state.finished){
			steps.push({cls:(_state.answers[i]==='left' && _seeds[i][0]===1) || (_state.answers[i]==='right' && _seeds[i][1]===1)? 'correct' : 'incorrect',clb:_state.step!==i?()=>_go_to(i):undefined});
		} else if(i===_state.finished){
			steps.push({cls:'current',clb:_state.step!==i?()=>_go_to(i):undefined});
		} else {
			steps.push({cls:''});
		}
	}

	let btn={};
	switch(_state.status){
		case 'question':
			btn={
				label:'Check Answer',
				cls:'grey',
				hidden:true,
			}
		break;
		case 'answered':
			btn={
				label:'Check Answer',
				cls:'blue',
				clb:_check_answer
			}
		break;
		case 'incorrect':
		case 'correct':
			if(_state.step===(_answers.length-1)){
				btn={
					label:'Check Answer',
					cls:'hidden',
					hidden:true,
				}
				steps[_answers.length-1]={cls:_state.status==='incorrect'?'incorrect':'correct'};
				rpoints.finish.classList.remove('hidden');
				rpoints.finish.removeAttribute('tabindex');
				rpoints.finish.removeAttribute('aria-hidden');
				instructions.remove();
			} else {
				btn={
					label:'Next',
					cls:_state.status==='correct'?'green':'red',
					clb:_state.step===_state.finished?_next:()=>_go_to(_state.step+1),
				}
			}
		break;
	}

	steps_component.render({
		btn,
		steps
	});
}

const _render_result = async ()=>{

	rpoints.result.removeAttribute('aria-live');
	if(!rpoints.result.classList.contains('hidden')){
		rpoints.result.classList.add('hidden');
		rpoints.result.setAttribute('aria-hidden','true');
		await wait(250);
	}

	if(!rpoints.desc.classList.contains('hidden')){
		rpoints.desc.classList.add('hidden');
		rpoints.desc.setAttribute('aria-hidden','true');
		await wait(250);
	}

	if(_state.status==='incorrect'){
		rpoints.result.classList.add('incorrect');
		rpoints.result_header.innerHTML='Incorrect';
		rpoints.result_text.innerHTML=_answers[_state.step];
		rpoints.result.classList.remove('hidden');
		rpoints.result.removeAttribute('aria-hidden');
		await wait(250);
		rpoints.result.setAttribute('aria-live','polite');
	} else if(_state.status==='correct'){
		rpoints.result.classList.remove('incorrect');
		rpoints.result_header.innerHTML='Correct!';
		rpoints.result_text.innerHTML=_answers[_state.step];
		rpoints.result.classList.remove('hidden');
		rpoints.result.removeAttribute('aria-hidden');
		await wait(250);
		rpoints.result.setAttribute('aria-live','polite');
	} else if(_state.status==='question' || _state.status==='answered'){
		rpoints.desc.classList.remove('hidden');
		rpoints.desc.removeAttribute('aria-hidden');
	}
}

const _ext={
	show:({
		parent,
		clb
	})=>{
		parent.insertBefore(el,parent.firstChild);
		_resize();
		init(clb);
	},
	hide:()=>{
		if(el.parentNode) el.parentNode.removeChild(el);
	}
}

export default _ext;
